// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"86fc1b9f","284":"3b654152","450":"bf4959ab","477":"b186b4de","637":"7100a2dd"}[chunkId] + ".chunk.js";
};